/**
 * Hallyu4U Enterprise API Configuration
 * All API keys and configurations for the theme
 * This file contains all necessary API configurations
 */

window.Hallyu4UConfig = {
  // Shopify Configuration - HallyuSuperstore
  shopify: {
    hallyuSuperstore: {
      storeUrl: 'https://hallyusuperstore19.myshopify.com',
      apiKey: '60c5590d89f3344cf363023fad226f2f',
      apiSecret: '0cea775a1676650c1c75a1189f30556d',
      accessToken: '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',
      webhookSecret: '5f0599e75b52d25a74e3b9b74038ba43478a522bb13e99899d6022674174e5b0',
      additionalToken: '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'
    },
    hallyu4u: {
      shopDomain: 'hallyu4u.myshopify.com',
      storeUrl: 'https://hallyu4u.myshopify.com',
      apiKey: '1999c3692ea3c6edae572ce51c921262',
      apiSecret: '653aa96394142f569872dc530ebd7bb5',
      accessToken: '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'
    }
  },

  // Shipping Carriers API
  shipping: {
    fedex: {
      apiKey: 'l7c2aa47261252450596202793894f554b',
      secretKey: '8ad43c04a33a4419a83c35e61880134a',
      accountNumber: '740561073',
      endpoint: 'https://apis.fedex.com/track/v1',
      testEndpoint: 'https://apis-sandbox.fedex.com/track/v1'
    },
    dhl: {
      apiKey: 'e3742df158674b62aa8a2c88514f7aa2',
      apiSecret: '9c2afd4792e341479c0d34c41ba96d33',
      endpoint: 'https://api-eu.dhl.com/track/shipments',
      testEndpoint: 'https://api-test.dhl.com/track/shipments'
    }
  },

  // AfterShip Configuration (Updated with actual API key)
  aftership: {
    apiKey: 'asat_60417bd33f9940b3b6eb2f9528732ac5',
    baseUrl: 'https://api.aftership.com/v4',
    trackingUrl: 'https://api.aftership.com/tracking/2024-10',
    shippingUrl: 'https://api.aftership.com/shipping/2024-07',
    labelUrl: 'https://api.aftership.com/postmen/v3',
    webhookUrl: 'https://webhooks.aftership.com/hallyu4u',
    enterprise: {
      enabled: true,
      features: ['real-time-tracking', 'bulk-operations', 'advanced-analytics', 'custom-branding'],
      rateLimit: 10000, // Enterprise rate limit per hour
      webhookRetries: 3
    }
  },

  // Warehouse Configuration
  warehouse: {
    korea: {
      address: {
        line1: '3F, 123 Gangnam-daero',
        line2: 'Gangnam-gu, Seoul 06232',
        country: 'South Korea',
        phone: '+82-2-1234-5678',
        email: 'warehouse@hallyu4u.com'
      },
      coordinates: {
        lat: 37.4979,
        lng: 127.0276
      },
      workingHours: {
        weekdays: '09:00 - 18:00 KST',
        saturday: '10:00 - 14:00 KST',
        sunday: 'Closed'
      },
      freeStorageDays: 45
    }
  },

  // Service Pricing
  pricing: {
    services: {
      consolidation: 5,
      photos: 3,
      inspection: 8,
      repacking: 4,
      giftWrap: 7,
      extraProtection: 6,
      insurance: 0.03 // 3% of declared value
    },
    storage: {
      daily: 0.5, // per package after free period
      weekly: 3,
      monthly: 10
    }
  },

  // Form Builder Integration
  formBuilder: {
    appId: 'powerful-form-builder',
    forms: {
      weBuyWeShip: 'we-buy-we-ship-form',
      youBuyWeShip: 'you-buy-we-ship-form',
      customsClearance: 'customs-clearance-form',
      returnRequest: 'return-request-form'
    }
  },

  // API Endpoints
  endpoints: {
    tracking: '/api/tracking',
    shipping: '/api/shipping',
    warehouse: '/api/warehouse',
    dashboard: '/api/dashboard',
    submissions: '/api/submissions',
    consolidation: '/api/consolidation'
  },

  // Cache Settings
  cache: {
    ttl: 3600, // 1 hour in seconds
    trackingTtl: 300, // 5 minutes for tracking updates
    shippingRatesTtl: 86400 // 24 hours for shipping rates
  },

  // Feature Flags
  features: {
    realTimeTracking: true,
    autoConsolidation: true,
    photoService: true,
    qualityInspection: true,
    expressCheckout: true,
    multiCurrency: true,
    loyaltyProgram: true
  },

  // Supported Carriers
  carriers: {
    korean: [
      { slug: 'cj-korea', name: 'CJ Logistics', tracking: /^[0-9]{10,12}$/ },
      { slug: 'hanjin', name: 'Hanjin Express', tracking: /^[0-9]{10,14}$/ },
      { slug: 'lotte', name: 'Lotte Global Logistics', tracking: /^[0-9]{10,12}$/ },
      { slug: 'korea-post', name: 'Korea Post', tracking: /^[A-Z]{2}[0-9]{9}KR$/ },
      { slug: 'gs-postbox', name: 'GS Postbox', tracking: /^[0-9]{12,14}$/ },
      { slug: 'cu-post', name: 'CU Post', tracking: /^[0-9]{10,12}$/ }
    ],
    international: [
      { slug: 'fedex', name: 'FedEx', tracking: /^[0-9]{12,22}$/ },
      { slug: 'dhl', name: 'DHL', tracking: /^[0-9]{10,11}$/ },
      { slug: 'ups', name: 'UPS', tracking: /^1Z[A-Z0-9]{16}$/ },
      { slug: 'ems', name: 'EMS', tracking: /^[A-Z]{2}[0-9]{9}[A-Z]{2}$/ },
      { slug: 'k-packet', name: 'K-Packet', tracking: /^[A-Z]{2}[0-9]{9}KR$/ }
    ]
  },

  // Initialize configuration
  init: function() {
    console.log('Hallyu4U Configuration Loaded');

    // Set up global API instances
    this.setupAPIs();

    // Initialize tracking
    this.initializeTracking();

    // Setup form handlers
    this.setupFormHandlers();
  },

  // Setup API instances
  setupAPIs: function() {
    // Initialize AfterShip
    if (window.aftershipAPI) {
      window.aftershipAPI.apiKey = this.aftership.apiKey;
    }

    // Initialize other APIs as needed
    console.log('APIs configured successfully');
  },

  // Initialize tracking systems
  initializeTracking: function() {
    if (this.features.realTimeTracking) {
      console.log('Real-time tracking enabled');
      // Initialize WebSocket or polling
    }
  },

  // Setup form handlers
  setupFormHandlers: function() {
    // Setup We Buy We Ship form
    const weBuyForm = document.getElementById('we-buy-form');
    if (weBuyForm) {
      console.log('We Buy We Ship form initialized');
    }

    // Setup You Buy We Ship form
    const youBuyForm = document.getElementById('you-buy-form');
    if (youBuyForm) {
      console.log('You Buy We Ship form initialized');
    }
  },

  // Utility functions
  utils: {
    // Validate tracking number
    validateTracking: function(trackingNumber, carrier) {
      const allCarriers = [...Hallyu4UConfig.carriers.korean, ...Hallyu4UConfig.carriers.international];
      const carrierInfo = allCarriers.find(c => c.slug === carrier);

      if (carrierInfo && carrierInfo.tracking) {
        return carrierInfo.tracking.test(trackingNumber);
      }

      return true; // Default to valid if no pattern
    },

    // Format currency
    formatCurrency: function(amount, currency = 'USD') {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency
      }).format(amount);
    },

    // Calculate shipping estimate
    calculateShipping: function(weight, method, destination) {
      // Basic calculation logic
      const rates = {
        express: { base: 25, perKg: 15 },
        standard: { base: 15, perKg: 8 },
        economy: { base: 10, perKg: 5 }
      };

      const rate = rates[method] || rates.standard;
      return rate.base + (weight * rate.perKg);
    }
  }
};

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => Hallyu4UConfig.init());
} else {
  Hallyu4UConfig.init();
}